import { OrderQuoteOfferStatus } from '@codezo/graphql';
import { StatusBadge } from '../../../../components/ui/status-badge';

/**
 * An offer batch the client is rejecting, named so the confirm dialog can say
 * which one.
 */
export type RejectTarget = { id: string; name: string };

const OFFER_STATUS_CONFIG: Record<
	string,
	{ label: string; tone: 'success' | 'warn' | 'info' | 'neutral' | 'danger' }
> = {
	[OrderQuoteOfferStatus.Draft]: { label: 'Draft', tone: 'neutral' },
	[OrderQuoteOfferStatus.Pending]: { label: 'Pending', tone: 'warn' },
	[OrderQuoteOfferStatus.PendingReview]: { label: 'Awaiting confirmation', tone: 'info' },
	[OrderQuoteOfferStatus.Submitted]: { label: 'Submitted', tone: 'info' },
	[OrderQuoteOfferStatus.Accepted]: { label: 'Accepted', tone: 'success' },
	[OrderQuoteOfferStatus.Rejected]: { label: 'Rejected', tone: 'danger' },
	[OrderQuoteOfferStatus.Cancelled]: { label: 'Cancelled', tone: 'neutral' },
	[OrderQuoteOfferStatus.Expired]: { label: 'Expired', tone: 'neutral' },
};

/**
 * The status of one offer batch, as the client reads it.
 *
 * It lived in `ClientOfferBatchCard` — the v1 batch card — and outlived it: v2
 * renders the same badge, and the card itself went with combination plans.
 */
export function OfferStatusBadge({ status }: { status: string }) {
	const config = OFFER_STATUS_CONFIG[status] ?? { label: status, tone: 'neutral' as const };
	return <StatusBadge active activeLabel={config.label} activeTone={config.tone} />;
}
